import React, { Component } from 'react';
import { getUserRole } from '../../../../services/common/util';

class FamilySearchMenu extends Component {
    render() {
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-4 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active">Family Menu</li>
                                    <li className="breadcrumb-item active">Families</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Families</h2>
                        </div>
                        {/^superadmin|^admin|^labtech|facilityadmin/.test(getUserRole().toLowerCase()) && (
                            <div className="col-md-8 col-12">
                                <div className="row breadcrumb-btns">
                                    <button className="btn" onClick={() => this.props.createFamily()}>
                                        <i className="fas fa-plus"></i> Create Family
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Quick Filter..."
                                onChange={this.props.onFilterTextChange}
                            />
                        </div>
                        <div className="col-md-2">
                            <select id="page-size" className="form-control" onChange={this.props.onPageSizeChanged}>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                            </select>
                        </div>
                        <div className="col-md-7 text-right">
                            <button className="btn btn-secondary mr-2" onClick={this.props.clearFilter}>
                                Clear Filters
                            </button>
                            <button className="btn btn-primary" onClick={this.props.onBtnExport}>
                                <i className="fas fa-download"></i> Export
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FamilySearchMenu;